import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import { formatDateTimeWithZone, getUserTimezone } from "../utils/dateUtils";

const WorkstationAuditModal = ({ show, onHide, auditData, workstation, loading }) => {
    // Get version from the first audit record
    const version = auditData && auditData.length > 0 ? auditData[0].version : null;
    const userTimezone = getUserTimezone();

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    Audit Details for {workstation}
                    <small className="text-muted ms-2">({userTimezone})</small>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" role="status" variant="primary">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        <p className="mt-3">Loading audit records...</p>
                    </div>
                ) : auditData && auditData.length > 0 ? (
                    <>
                        {/* Summary Section */}
                        <div className="alert alert-info mb-3">
                            <h6 className="mb-2">Summary</h6>
                            <div className="row">
                                <div className="col-md-6">
                                    <strong>Workstation:</strong> {workstation}
                                </div>
                                <div className="col-md-6">
                                    <strong>Version:</strong> {version || "Unknown"}
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-12">
                                    <strong>Total Records:</strong> {auditData.length}
                                </div>
                            </div>
                        </div>

                        {/* Detail Section */}
                        <h6>Audit Records</h6>
                        <div className="table-responsive">
                            <table className="table table-striped table-sm">
                                <thead className="table-dark">
                                    <tr>
                                        <th>Event Time</th>
                                        <th>Source (IP)</th>
                                        <th>Event</th>
                                        <th>Subject</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {auditData.map((record, index) => (
                                        <tr key={index}>
                                            <td>{formatDateTimeWithZone(record.eventTime)}</td>
                                            <td>
                                                {record.source ? (
                                                    <span className="badge bg-primary">{record.source}</span>
                                                ) : (
                                                    <span className="text-muted">—</span>
                                                )}
                                            </td>
                                            <td>{record.event || "—"}</td>
                                            <td style={{ maxWidth: "400px", wordWrap: "break-word" }}>
                                                {record.subject || "—"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                ) : (
                    <div className="alert alert-info">No audit records found for this workstation on this date.</div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={onHide}>
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default WorkstationAuditModal;
